import React from "react";
import styled from "styled-components";
import { PageSectionArticle, TextEditor } from "../common";
import { toHTML } from "../../utils/helpers/index";
import { respondTo } from "../../styles";

const StartPageIntroArticleContent = styled.div`
  width: 100%;

  ${respondTo.lg` 
    max-width: 800px;
    padding-top: 40px;
  `}
`;
export const StartPageIntro = ({ startIntro }) => {
  const { heading, body } = startIntro;
  return (
    <PageSectionArticle>
      <StartPageIntroArticleContent>
        <h2>{heading}</h2>
        <TextEditor dangerouslySetInnerHTML={{ __html: toHTML(body) }} />
      </StartPageIntroArticleContent>
    </PageSectionArticle>
  );
};
